/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 *
 * @Author: JB (jb@codecorsair.com)
 * @Date: 2016-12-09 14:42:59
 * @Last Modified by: JB (jb@codecorsair.com)
 * @Last Modified time: 2017-01-18 12:10:02
 */
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var IDGenCharacters = 'abcdefghijklmnopqrstuwxyzABCDEFGHIJKLMNOPQRSTUWXYZ';
var IDGenCharactersLength = IDGenCharacters.length;
function generateID(length) {
    var id = '';
    var counter = length;
    while (--counter >= 0) {
        id += IDGenCharacters.charAt(Math.floor(Math.random() * IDGenCharactersLength));
    }
    return id;
}
exports.generateID = generateID;
// a global list of module names to ensure unique generated action type names across modules.
var globalModuleIDs = {};
var Module = (function () {
    function Module(options) {
        this.actionDefs = {};
        this.reducerCreated = false;
        this.initialState = options.initialState;
        this.actionExtraData = options.actionExtraData || (function () { return {}; });
        this.postReducer = options.postReducer || null;
        // generate a unique id for this module.
        this.moduleID = generateID(6);
        var retryCount = 10;
        while (typeof globalModuleIDs[this.moduleID] !== 'undefined' && --retryCount >= 0) {
            this.moduleID = generateID(6);
        }
        // extremely unlikely to ever happen
        if (typeof globalModuleIDs[this.moduleID] !== 'undefined')
            throw new Error('failed to generate a unique module id');
        globalModuleIDs[this.moduleID] = this.moduleID;
    }
    // combined
    Module.prototype.createAction = function (options) {
        if (this.reducerCreated)
            throw new Error("createAction may only be called before createReducer.");
        var action = options.action, reducer = options.reducer;
        var type = options.type;
        if (typeof type === 'undefined') {
            // generate a type 
            type = this.moduleID + '/' + generateID(6);
            var retry = 10;
            while (typeof this.actionDefs[type] !== 'undefined' && --retry >= 0) {
                type = this.moduleID + '/' + generateID(6);
            }
        }
        if (typeof this.actionDefs[type] !== 'undefined')
            throw new Error('duplicate type name provided to createAction or type name generation failed to generate a unique type name');
        this.actionDefs[type] = reducer || function (s, a) { return {}; };
        var actionExtraData = this.actionExtraData;
        if (action.length == 0) {
            return function () {
                var actionResult = action();
                if (typeof actionResult === 'function') {
                    return function (dispatch, state) {
                        return __assign({}, actionResult(dispatch, state), { type: type }, actionExtraData());
                    };
                }
                return __assign({}, actionResult, { type: type }, actionExtraData());
            };
        }
        else if (action.length === 1) {
            return function (a) {
                var actionResult = action(a);
                if (typeof actionResult === 'function') {
                    return function (dispatch, state) {
                        return __assign({}, actionResult(dispatch, state), { type: type }, actionExtraData());
                    };
                }
                return __assign({}, actionResult, { type: type }, actionExtraData());
            };
        }
        else if (action.length === 2) {
            return function (a, b) {
                var actionResult = action(a, b);
                if (typeof actionResult === 'function') {
                    return function (dispatch, state) {
                        return __assign({}, actionResult(dispatch, state), { type: type }, actionExtraData());
                    };
                }
                return __assign({}, actionResult, { type: type }, actionExtraData());
            };
        }
        else if (action.length === 3) {
            return function (a, b, c) {
                var actionResult = action(a, b, c);
                if (typeof actionResult === 'function') {
                    return function (dispatch, state) {
                        return __assign({}, actionResult(dispatch, state), { type: type }, actionExtraData());
                    };
                }
                return __assign({}, actionResult, { type: type }, actionExtraData());
            };
        }
        else if (action.length === 4) {
            return function (a, b, c, d) {
                var actionResult = action(a, b, c, d);
                if (typeof actionResult === 'function') {
                    return function (dispatch, state) {
                        return __assign({}, actionResult(dispatch, state), { type: type }, actionExtraData());
                    };
                }
                return __assign({}, actionResult, { type: type }, actionExtraData());
            };
        }
        else if (action.length === 5) {
            return function (a, b, c, d, e) {
                var actionResult = action(a, b, c, d, e);
                if (typeof actionResult === 'function') {
                    return function (dispatch, state) {
                        return __assign({}, actionResult(dispatch, state), { type: type }, actionExtraData());
                    };
                }
                return __assign({}, actionResult, { type: type }, actionExtraData());
            };
        }
        else if (action.length === 6) {
            return function (a, b, c, d, e, f) {
                var actionResult = action(a, b, c, d, e, f);
                if (typeof actionResult === 'function') {
                    return function (dispatch, state) {
                        return __assign({}, actionResult(dispatch, state), { type: type }, actionExtraData());
                    };
                }
                return __assign({}, actionResult, { type: type }, actionExtraData());
            };
        }
        else if (action.length === 7) {
            return function (a, b, c, d, e, f, g) {
                var actionResult = action(a, b, c, d, e, f, g);
                if (typeof actionResult === 'function') {
                    return function (dispatch, state) {
                        return __assign({}, actionResult(dispatch, state), { type: type }, actionExtraData());
                    };
                }
                return __assign({}, actionResult, { type: type }, actionExtraData());
            };
        }
    };
    Module.prototype.createReducer = function () {
        var _this = this;
        this.reducerCreated = true;
        var postReducer = this.postReducer;
        if (postReducer === null) {
            return function (state, action) {
                if (state === void 0) { state = _this.initialState; }
                var def = _this.actionDefs[action.type];
                if (typeof def === 'undefined' || def === null)
                    return state;
                return __assign({}, state, def(state, action));
            };
        }
        else {
            return function (state, action) {
                if (state === void 0) { state = _this.initialState; }
                var def = _this.actionDefs[action.type];
                if (typeof def === 'undefined' || def === null)
                    return state;
                return postReducer(__assign({}, state, def(state, action)));
            };
        }
    };
    return Module;
}());
exports.Module = Module;
